import { Roboto } from 'next/font/google';

const roboto = Roboto({
  weight: ['400', '500', '600', '700'],
  style: ['normal', 'italic'],
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-family',
  preload: true,
});

export default roboto;
